/* istanbul ignore file */

/**
 * This is a Bullet App convention file.
 * DON'T RENAME OR MOVE TO OTHER FOLDERS.
 *
 * Please only export a default method e.g. called `getRoutes`,
 * which returns an array of `Route` (from react-router-dom v4.x)
 */

import React from 'react';
import {Route, Switch} from 'react-router-dom';
import Loadable from 'react-loadable';
import Spinner from '@stubhub/react-spinner';
// Import {Login} from '@stubhub/bullet-app-login';
import ReloadPage from '@stubhub/react-reload-page';
import PrivateRoute from '@stubhub/react-private-route';

const REACT_APP_ENABLE_NONE_UI_LOGIN = /^(true|1)$/i.test(process.env.REACT_APP_ENABLE_NONE_UI_LOGIN);

const AuthRoute = (props) => (!REACT_APP_ENABLE_NONE_UI_LOGIN ? <PrivateRoute {...props} /> : <Route {...props} />);

const Payments = Loadable({
  loader: () => import(/* webpackChunkName: "payments" */ './myaccount/payments'),
  loading: Spinner,
});

import Layout from './myaccount/layout';

const shouldHideSideLayout = (location) => {
  const paymentVerificationPage = /my\/sellerinfo\/pihw/;
  const {pathname} = location;

  return [paymentVerificationPage].some((path) => {
    return path.exec(pathname);
  });
};

const MainLayout = (props) => {
  const {match, location} = props;
  const hideSideLayout = shouldHideSideLayout(location);

  return (
    <Layout className={hideSideLayout ? 'hideSide' : ''}>
        <Switch>
          <Route path={`${match.path}/sellerinfo/pihw`} render={(props) => <Payments {...props} />} key="pv" />
          {/* <Route path={`${match.path}/order/:orderId/tickets`} render={(props) => <Tickets {...props}/>} key="tickets"/> */}
          <Route path={`${match.path}/*`} component={ReloadPage} key="spa" />
        </Switch>
      </Layout>
  );
};

export default function getRoutes({currentLocale, defaultLocale}) {
  const lang = currentLocale !== defaultLocale ? currentLocale.substr(0, 2) : '';
  const langPath = lang ? `/${lang}` : '';
  const routes = [<AuthRoute path={`${langPath}/my`} component={MainLayout} key="myaccount" />];

  return routes;
}
